
export default {
  emits: ['click', 'mouseover'],
  props: {
    linkClass: {
      type: String,
      default: 'link'
    },
    url: {
      type: String,
      default: '#'
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: '_self'
    },
    rel: {
      type: String,
      default: undefined
    },
    openModal: {
      type: String,
      default: ''
    },
    isSlot: {
      type: Boolean,
      default: false
    },
    eventType: {
      type: String,
      default: ''
    }
  },
  methods: {
    emitEvent(e) {
      if (this.openModal) {
        this.$emit('openModal', this.openModal)
      }
      if (this.eventType) {
        this.$emit('eventType', this.eventType)
      }
      this.$emit('click', e)
    },
    emitEventHover(e) {
      this.$emit('mouseover', e)
    }
  }
}
